import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultInstallmentSaleOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'installment-sale-page-two-list',
        type: 'ListItemsSection',
        props: { sx: { gap: 0.5 } },
        children: {
          default: [
            {
              id: 'installment-sale-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is an installment sale right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'installment-sale-page-two-estate',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is close to the federal estate tax exemption, an installment sale can provide significant tax benefits.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'installment-sale-page-two-gifts',
              type: 'PresentationListItem',
              props: {
                title: 'Making irrevocable gifts',
                description:
                  "For many grantors there is often a fear of making gifts. The flexibility in structuring the sale allows grantors to give as little (or as much) as they're comfortable with, and on their timetable.",
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'installment-sale-page-two-grantor-status',
              type: 'PresentationListItem',
              props: {
                iconColor: 'PRIMARY',
                title: 'Grantor trust status',
                description:
                  'The sale of assets to a grantor trust requires the grantor to pay the trust’s income taxes. It is necessary to ensure that the grantor has sufficient liquid assets to pay these taxes each year.',
                iconType: 'check',
              },
            },
            {
              id: 'installment-sale-page-two-interest',
              type: 'PresentationListItem',
              props: {
                title: 'Interest payments',
                description:
                  'Any asset sold should produce enough income to service the note; to the extent an asset does not produce sufficient income during the note term additional planning considerations are necessary.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'installment-sale-page-two-asset-value',
              type: 'PresentationListItem',
              props: {
                title: 'Asset value decrease',
                description:
                  'If the assets sold to the trust decrease in value, the trust still has a liability due to the grantor. The grantor can choose to forgive the loan using exemption.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'installment-sale-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether an installment sale aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
